var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showTag
    ? _c(
        "div",
        {
          staticClass: "avue-tags",
          on: {
            click: function ($event) {
              _vm.contextmenuFlag = false
            },
          },
        },
        [
          _vm.contextmenuFlag
            ? _c(
                "div",
                {
                  staticClass: "avue-tags__contentmenu",
                  style: {
                    left: _vm.contentmenuX + "px",
                    top: _vm.contentmenuY + "px",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "item", on: { click: _vm.closeOthersTags } },
                    [_vm._v("关闭其他")]
                  ),
                  _c(
                    "div",
                    { staticClass: "item", on: { click: _vm.closeAllTags } },
                    [_vm._v("关闭全部")]
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "avue-tags__box",
              class: { "avue-tags__box--close": !_vm.website.isFirstPage },
            },
            [
              _c(
                "el-tabs",
                {
                  attrs: { closable: _vm.tagLen !== 1, type: "card" },
                  on: { edit: _vm.menuTag, "tab-click": _vm.openTag },
                  nativeOn: {
                    contextmenu: function ($event) {
                      return _vm.handleContextmenu.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.active,
                    callback: function ($$v) {
                      _vm.active = $$v
                    },
                    expression: "active",
                  },
                },
                _vm._l(_vm.tagList, function (item) {
                  return _c("el-tab-pane", {
                    key: item.value,
                    attrs: { label: item.label, name: item.value },
                  })
                }),
                1
              ),
              _c(
                "el-dropdown",
                { staticClass: "avue-tags__menu" },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "mini", type: "primary" } },
                    [
                      _vm._v("\n\t\t\t\t更多\n\t\t\t\t"),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right",
                      }),
                    ]
                  ),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.closeOthersTags.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("关闭其他")]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.closeAllTags.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("关闭全部")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }